import Cell, { CellProps } from './Cell'
export default Cell
export type { CellProps }
